import { ValidationService } from "aspnet-client-validation";

/**
 * Bootstrapper for the validation service that replaces jQuery + jQuery unobtrusive validation.
 * Relies on the data-val-* attributes on the form elements (output by MVC) to determine the validation rules.
 * 
 * From https://github.com/haacked/aspnet-client-validation
 */
export class ValidationBootstrap {
    public static Init() {
        // When debugging, pass console to the validation service to see output in the dev tools console.
        window.validationService = new ValidationService();

        if (window.validators) {
            // Enumerate the window.validators dictionary that will have been populated by the custom validators
            // and add each validator to the validation service.
            // These custom validators must be added before calling bootstrap below.
            Object.keys(window.validators).forEach(validatorName => {
                let validator = window.validators[validatorName];

                window.validationService.addProvider(validatorName,
                    (value, element, params) => validator.validate(value, element as HTMLInputElement, params));
            });
        }

        let hiddenFieldValidationFlag = document.getElementById("allow-hidden-field-validation");
        if (hiddenFieldValidationFlag) {
            // The payment method checkboxes (and agree to checkbox) are hidden as they are styled, if we don't turn this on then they won't get validated.
            window.validationService.allowHiddenFields = true;
        }

        // The delay before validation occurs after an input changes.
        window.validationService.debounce = 0;

        // As the delivery options are dynamically reloaded, we need the watch option to rebind them.
        window.validationService.bootstrap({ watch: true });
    }
}

document.addEventListener("DOMContentLoaded", () => { ValidationBootstrap.Init(); });
